import LegalLayout from '../components/LegalLayout';

const SECTIONS = [
  {
    id: 'acceptance',
    heading: 'Acceptance of Terms',
    body: (
      <>
        <p>
          By accessing or using FreeMansLive (the "Site"), including linking your Kick account, earning or
          spending points, or using any feature described below, you agree to these Terms of Service. If you
          don't agree, please don't use the Site.
        </p>
        <p>FreeMansLive is a fan-run rewards site for the FreeMansLive Kick channel and is not affiliated with, endorsed by, or operated by Kick.com.</p>
      </>
    ),
  },
  {
    id: 'eligibility',
    heading: 'Eligibility',
    body: (
      <p>
        You must be at least 13 years old to use the Site. If you're under the age of majority in your
        jurisdiction, you should only use the Site with a parent or guardian's permission. By using the Site
        you confirm you meet these requirements.
      </p>
    ),
  },
  {
    id: 'account',
    heading: 'Your Account',
    body: (
      <>
        <p>
          You sign in with your Kick account via Kick's official OAuth login — we never see or store your Kick
          password. Your points balance and activity are tied to that Kick account.
        </p>
        <p>
          You're responsible for keeping your Kick account secure. We may suspend or reset a site account's
          points balance if we reasonably believe it's being used to abuse, exploit, or cheat the Site's
          systems.
        </p>
      </>
    ),
  },
  {
    id: 'points',
    heading: 'Points Have No Cash Value',
    body: (
      <>
        <p>
          Points are a virtual, in-site scorekeeping mechanic. They are earned by watching and participating in
          the FreeMansLive Kick stream and chat. Points:
        </p>
        <ul className="list-disc pl-5 flex flex-col gap-1.5">
          <li>have no monetary value and cannot be purchased, sold, exchanged for real money, or cashed out;</li>
          <li>are not a currency, security, or financial instrument of any kind;</li>
          <li>can only be spent inside the Site — on the Store, Cases, Raffles, Predictions, mini-games, Rain, and Text-to-Speech;</li>
          <li>may be adjusted, reset, or removed by staff to correct errors or abuse.</li>
        </ul>
      </>
    ),
  },
  {
    id: 'features',
    heading: 'Site Features',
    body: (
      <>
        <p>The Site includes several point-based features, all of which use points only — never real money:</p>
        <ul className="list-disc pl-5 flex flex-col gap-1.5">
          <li><b>Store</b> — redeem points for items; redemptions are fulfilled by staff and may take time.</li>
          <li><b>Cases &amp; Raffles</b> — spend points for a chance at a listed prize; odds are shown in-app.</li>
          <li><b>Predictions</b> — wager points on chat predictions; outcomes are decided by stream events.</li>
          <li><b>Mini-games</b> (slots, dice, roulette, coinflip, blackjack, duels) — entertainment wagers of points against the house or other viewers, capped at 100 points per bet.</li>
          <li><b>Rain</b> — periodic point drops to active chatters while live.</li>
          <li><b>Text-to-Speech</b> — spend points to have a message read aloud on stream in a chosen voice. Messages may not contain hate speech, slurs, harassment, explicit content, or spammed/repeated characters, and are subject to removal.</li>
        </ul>
      </>
    ),
  },
  {
    id: 'prizes',
    heading: 'Prizes & Fulfillment',
    body: (
      <p>
        Physical or account-based prizes (Store items, raffle/case prizes) are fulfilled at staff's discretion
        and may require you to provide delivery or account details through your profile settings. We're not
        responsible for delays caused by incorrect information you've provided, or by third parties (shipping
        carriers, other platforms).
      </p>
    ),
  },
  {
    id: 'conduct',
    heading: 'Prohibited Conduct',
    body: (
      <>
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 flex flex-col gap-1.5">
          <li>exploit bugs, race conditions, or vulnerabilities to gain points or prizes;</li>
          <li>use multiple accounts to manipulate rain, raffles, predictions, or the leaderboard;</li>
          <li>harass, threaten, or impersonate others through the Site or its chat-connected features;</li>
          <li>use the Text-to-Speech or chat features to post illegal, hateful, or harassing content;</li>
          <li>automate or script interactions with the Site outside of normal chat use.</li>
        </ul>
        <p>Violating these may result in a points reset, feature suspension, or a Site ban.</p>
      </>
    ),
  },
  {
    id: 'termination',
    heading: 'Suspension & Termination',
    body: (
      <p>
        We may suspend or terminate your access to the Site at any time, with or without notice, for conduct we
        believe violates these Terms or harms the Site or its community.
      </p>
    ),
  },
  {
    id: 'disclaimer',
    heading: 'Disclaimers & Limitation of Liability',
    body: (
      <p>
        The Site is provided "as is," without warranties of any kind. We don't guarantee uninterrupted
        availability, error-free operation, or that any particular prize will remain in stock. To the fullest
        extent permitted by law, FreeMansLive and its operators aren't liable for indirect, incidental, or
        consequential damages arising from your use of the Site.
      </p>
    ),
  },
  {
    id: 'changes',
    heading: 'Changes to These Terms',
    body: (
      <p>
        We may update these Terms from time to time. Continued use of the Site after changes are posted means
        you accept the updated Terms.
      </p>
    ),
  },
  {
    id: 'contact',
    heading: 'Contact',
    body: (
      <p>
        Questions about these Terms? Reach out at{' '}
        <a href="mailto:Freemanthe3rd@gmail.com" className="text-[#ff544a] hover:underline font-bold">
          Freemanthe3rd@gmail.com
        </a>
        .
      </p>
    ),
  },
];

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      updated="August 11, 2026"
      intro="The rules for using FreeMansLive's site, points, and features. This is a fan rewards site — points never involve real money."
      sections={SECTIONS}
    />
  );
}
